<div role="alert"
     [ngClass]='"alert alert-" + type + (closable ? " alert-alert-dismissible" : "") + (noIcon ? " no-icon" : "")'>
  <strong *ngIf='alertTittle as title'>{{ title }}</strong>
  {{ alertContent }}
  <ng-content></ng-content>
  <button *ngIf='closable' type='button' aria-label='Zamknij' (click)='onClose.emit()'>
    <span aria-hidden='true'>&times;</span>
  </button>
</div>
